// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kom9t","field":"styles_field__10WdG","fieldCol":"styles_fieldCol__2qx14","diffCol":"styles_diffCol__gHiqh","diff":"styles_diff__ZrnTD"};